import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LocaleContextProvider from './context/LocaleContext';
import AuthProvider from './context/AuthContext';

import './shared/style/styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<LocaleContextProvider>
		<AuthProvider>
			<App />
		</AuthProvider>
	</LocaleContextProvider>,
);

reportWebVitals();
